export class CloudActInfo {
  constructor () {
    this.id = ''
    this.showButton = 1
    this.status = 1
    this.type = 3
    this.actIcon = ''
    this.actTitle = ''
    this.startTime = ''
    this.endTime = ''
  }
}